import { createAction, props } from '@ngrx/store';
import { FileDetails } from './file-details.state';
import { FileStatus } from '../../core/models/file-status.model';

export const loadFileDetails = createAction(
  '[File Details Page] Load File Details',
  props<{ id: number }>()
);

export const loadFileDetailsSuccess = createAction(
  '[File Details API] Load File Details Success',
  props<{ file: FileDetails }>()
);

export const loadFileDetailsFailure = createAction(
  '[File Details API] Load File Details Failure',
  props<{ error: string }>()
);

export const loadFileStatuses = createAction(
  '[File Details Page] Load File Statuses'
);

export const loadFileStatusesSuccess = createAction(
  '[File Details API] Load File Statuses Success',
  props<{ statuses: FileStatus[] }>()
);

export const loadFileStatusesFailure = createAction(
  '[File Details API] Load File Statuses Failure',
  props<{ error: string }>()
);

export const updateFileStatus = createAction(
  '[File Details Page] Update File Status',
  props<{ id: number; fileStatusId: number }>()
);

export const updateFileStatusSuccess = createAction(
  '[File Details API] Update File Status Success',
  props<{ id: number; fileStatusId: number }>()
);

export const updateFileStatusFailure = createAction(
  '[File Details API] Update File Status Failure',
  props<{ error: string }>()
);
